import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import { CheckboxField } from './../../../../../../components/fields';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getCaliforniaDisclosure } from './assets/disclosure';
import { getSignatures, sign } from '../../../../../../reducers/signatures';
import { setProgressionProperties, getAdmin } from '../../../../../../reducers/onboarding';
import Signature from '../../../../../../components/signature';
import { getUserBackgroundChecks, saveUserBackgroundCheck, updateBackgroundCheck } from '../../../../../../reducers/backgroundCheck';
import { Signatures } from '../../../../../../utilities/signatureTypes';
import mixpanel from 'mixpanel-browser';

class BackgroundCheckCDRBStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'BackgroundCheckCDRBStep' } });

        const {
            role,
            admin,
            client,
            job,
            getAdmin,
            getSignatures,
            setProgressionProperties,
            userId,
            backgroundCheck,
            getUserBackgroundChecks,
            saveUserBackgroundCheck
        } = this.props;

        const { calif_disclosure_signed, calif_report_requested } = backgroundCheck;
        const createBackgroundCheckIfMissing = response =>
            response.length === 0 && saveUserBackgroundCheck(userId, job.id, { calif_disclosure_signed, calif_report_requested });

        if (!backgroundCheck.id) {
            getUserBackgroundChecks(userId, createBackgroundCheckIfMissing);
        }

        getSignatures(role, signaturesResult =>
            setProgressionProperties({
                agreementBGcdrb: signaturesResult.find(s => s.name === `${Signatures.types.BG_CHECK_CDRB.name}:${job.id}`) !== undefined
            })
        );

        if (!admin) {
            getAdmin(client.admin_id);
        }
    }

    submit({ acknowledgeCDRBGetCopy }, action) {
        const { role, job, sign, setProgressionProperties, backgroundCheck, updateBackgroundCheck } = this.props;
        const { calif_disclosure_signed, calif_report_requested } = backgroundCheck;

        if (!calif_disclosure_signed) {
            sign(role, `${Signatures.types.BG_CHECK_CDRB.name}:${job.id}`, ({ id }) => {
                setProgressionProperties({ agreementBGcdrb: true });

                updateBackgroundCheck(backgroundCheck.id, { calif_disclosure_signed: id, calif_report_requested: acknowledgeCDRBGetCopy }, action);
            });
        }

        const requestCopyUpdated = calif_report_requested !== acknowledgeCDRBGetCopy;
        if (calif_disclosure_signed && requestCopyUpdated) {
            updateBackgroundCheck(backgroundCheck.id, { calif_report_requested: acknowledgeCDRBGetCopy }, action);
            return;
        }

        action();
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, isCopyRequested, admin, job, progression } = this.props;
        if (!admin || !progression || progression.agreementBGcdrb === undefined) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage id={'onboard2.backgroundCheckCDRB.intro'} defaultMessage={'California Disclosure'} tagName={'h5'} />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <div className="scrolled">{getCaliforniaDisclosure(admin)}</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Field
                            name="acknowledgeCDRBGetCopy"
                            component={CheckboxField}
                            checked={isCopyRequested === true}
                            placeholder={messages.acknowledgeCDRBGetCopy}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Signature name={`${Signatures.types.BG_CHECK_CDRB.name}:${job.id}`} />
                    </div>
                </div>

                <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.signAndContinue} /> }} />
            </form>
        );
    }
}

BackgroundCheckCDRBStep = reduxForm(formSettings)(BackgroundCheckCDRBStep);

const selector = formValueSelector('contractor-onboarding-wizard');
const mapStateToProps = state => {
    let progression = state.onboarding.progression;
    const backgroundCheck = state.backgroundCheck.current;
    const profile = state.identity.profile;

    return {
        role: state.identity.role,
        job: state.onboarding.job,
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        progression,
        backgroundCheck,
        isCopyRequested: selector(state, 'acknowledgeCDRBGetCopy') && selector(state, 'acknowledgeCDRBGetCopy') === true,
        initialValues: {
            acknowledgeCDRBGetCopy: backgroundCheck.calif_report_requested
        },
        userId: profile ? profile.id : undefined
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            getSignatures: getSignatures,
            sign: sign,
            setProgressionProperties: setProgressionProperties,
            getUserBackgroundChecks,
            saveUserBackgroundCheck,
            updateBackgroundCheck
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundCheckCDRBStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/backgroundCheckCDRB.jsx